export default __webpack_public_path__ + "static/img-1-a1d89b662e11bb6e8b22b05891c61062.svg";